import { render, staticRenderFns } from "./Semen.vue?vue&type=template&id=120690af&"
import script from "./Semen.vue?vue&type=script&lang=js&"
export * from "./Semen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports